import { useMutation } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { useDispatch } from "react-redux";
import {
  getExportBatchSize,
  getExportDataForBatch,
} from "src/services/booking.services";
import { exportToExcel } from "src/uitils/exportToExcel";
import { generatePDF } from "src/uitils/exportToPdf";
function useExportData() {
  const dispatch = useDispatch();

  const batchMutation = useMutation({
    mutationKey: ["batchMutation"],
    mutationFn: async (params) => {
      const data = await getExportBatchSize(params);
      return { responseData: data, params };
    },
    onMutate: () => {
      toast.loading("Calculating batch size...");
    },
    onSuccess: (data) => {
      toast.dismiss();

      const { responseData, params } = data;
      const batchSize = responseData.totalBatch;


      if (batchSize > 0) {
        const promises = [];
        for (let i = 1; i <= batchSize; i++) {
          const paramsForBatch = {
            ...params,
            batch: i,
          };
          const promise = getExportDataForBatch(paramsForBatch);
          promises.push(promise);
        }

        toast.loading("Getting export data for batch...");
        Promise.all(promises)
          .then((results) => {
            const filterDetails = results[0].filterDetails;
            const exportData = results
              .map((result) => result.bookingOrders)
              .flat();

            if (params.fileType === "excel") {
              const dataToExport = {
                filterDetails,
                data: exportData,
              };
              exportToExcel(dataToExport);
            } else if (params.fileType === "pdf") {
              (async () => {
                await generatePDF(exportData, filterDetails);
              })();
            }

          })
          .catch((error) => {
            toast.dismiss();
            toast.error("Error fetching batch data");
            console.error("Error fetching batch data:", error);
          })
          .finally(() => {
            toast.dismiss();
          });
      } else {
        toast.error("No data to export");
      }
    },
    onError: (error) => {
      toast.dismiss();
      toast.error("Error getting batch size");
      console.log("onError", error);
    },
  });


  // Return the refetch function to be called on button click
  return {
    exportData: (params) => batchMutation.mutate(params), // Pass params to refetch
  };
}

export default useExportData;
